export default function round() {
  return function link(number, places = 0, def = 0) {
    if (typeof number !== 'number') {
      return def;
    }

    const multiplier = Math.pow(10, places);
    return Math.round(number * multiplier) / multiplier;
  };
}
